import React from 'react';

import IntegrationsCell from 'app/components/data-table/IntegrationsCell';
import TagsCell from 'app/components/data-table/TagsCell';
import TextCell from 'app/components/data-table/TextCell';

/**
 * Transform pipelineIntegrations to the format expected by IntegrationsCell
 */
function transformPipelineIntegrations(pipelineIntegrations) {
  if (!pipelineIntegrations) return [];
  return pipelineIntegrations.map(pipelineInt => ({
    starterkitId: pipelineInt.integration?.starterkitId,
    name: pipelineInt.integration?.name,
  }));
}

export default function buildBulkPlaybookUpdateTableColumns({ showTags }) {
  return [
    {
      name: 'Pipeline Name',
      cell: row => <TextCell bubbleClickEvent text={row.name} />,
      sortable: true,
      sortField: 'name',
      grow: 2,
    },
    {
      name: 'Integrations',
      cell: row => (
        <IntegrationsCell bubbleClickEvent integrations={transformPipelineIntegrations(row.pipelineIntegrations)} />
      ),
      sortable: true,
      sortField: 'integrations',
    },
    ...(showTags
      ? [
          {
            name: 'Tags',
            cell: row => <TagsCell tags={row.pipelineTags} />,
            width: '250px',
          },
        ]
      : []),
    {
      name: 'Writekey',
      cell: row => <TextCell bubbleClickEvent text={row.writekey} />,
      sortable: true,
      sortField: 'writekey',
    },
    {
      name: 'Cluster',
      cell: row => <TextCell bubbleClickEvent text={row.cluster?.name} />,
      sortable: true,
      sortField: 'cluster',
    },
  ];
}
